import { FILTER_SAVED } from '../actionTypes/device.types';

export function saveFilterDevice(data: object) {
  return {
    type: FILTER_SAVED,
    payload: {
      ...data,
    },
  };
}
